import { render, staticRenderFns } from "./TaskTrackingView.vue?vue&type=template&id=598012b2&lang=pug&"
import script from "./TaskTrackingView.vue?vue&type=script&lang=js&"
export * from "./TaskTrackingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports